import classNames from "classnames";

import { BoldText } from "components/BoldText/BoldText";
import { BaseLayout } from "components/BaseLayout/BaseLayout";

import styles from "./styles.module.scss";
import { ExpensesFooter } from "./ExpensesFooter";
import { ExpensesBody } from "./ExpensesBody";

const Header = (): JSX.Element => (
  <BoldText className={styles.groupTitle}>Статьи затрат</BoldText>
);

export const Expenses = (): JSX.Element => (
  <BaseLayout
    className={classNames("ml-2 mt-3 mb-3", styles.container)}
    header={<Header />}
    footer={<ExpensesFooter />}
  >
    <ExpensesBody />
  </BaseLayout>
);
